module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniffspot-qr-code-1155.3b7197ce80bb4aa8.png"+" 1155w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniffspot-qr-code-1155.3b7197ce80bb4aa8.png",width: 1155,height: 1155}],
        src: "https://static.sniffspot.com/packs/img/sniffspot-qr-code-1155.3b7197ce80bb4aa8.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniffspot-qr-code-1155.3b7197ce80bb4aa8.png"},
        
        width: 1155,
        height: 1155
      }